import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { defaultTheme } from '../../../../lib/themes';
import darkTheme from '../../../../lib/themes/darkTheme';
import { isLightTheme } from '../../../../lib/themes/theme';

const currentTheme = isLightTheme() ? defaultTheme : darkTheme;

export const useStyles = makeStyles((theme: Theme) => {
  return {
    button: {
      'backgroundColor': currentTheme.palette.primary.teal,
      'color': currentTheme.palette.primary.white,
      'padding': `${theme.spacing(1)} ${theme.spacing(3)}`,
      '&:hover': {
        backgroundColor: currentTheme.palette.primary.teal,
        borderColor: 'none',
        boxShadow: 'none',
      },
    },
    container: {
      borderBottom: `1px solid ${currentTheme.palette.primary.grey13}`,
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(0.5),
    },
    sectionTitle: {
      color: currentTheme.palette.primary.steelGrey,
      fontSize: currentTheme.font.mediumFontSize,
      fontWeight: currentTheme.font.weight.thick,
    },
    content: {
      color: currentTheme.palette.primary.rollingStone,
      fontSize: currentTheme.font.mediumFontSize,
    },
    approved: {
      color: currentTheme.palette.primary.teal,
    },
    rejected: {
      color: currentTheme.palette.error.main,
    },
    thick: {
      fontWeight: currentTheme.font.weight.thick,
    },
    typography: {
      fontSize: currentTheme.typography.fontSize,
    },
    dataRow: {
      paddingBottom: theme.spacing(0.5),
    },
    historyButton: {
      minWidth: 10,
      marginRight: theme.spacing(1),
    },
    errorButton: {
      'background': 'transparent',
      'color': currentTheme.palette.error.main,
      'cursor': 'default',
      'marginRight': theme.spacing(0.5),
      'minWidth': theme.spacing(4),
      '&:hover': {
        backgroundColor: currentTheme.palette.primary.grey3,
      },
    },
  };
});
